<section class="sp-page">
	<header class="sp-page__header">
		<div>
			<h1 class="sp-page__title">Structure programmatique</h1>
			<p class="sp-page__subtitle">Définissez le type d’intervention à partir duquel commencent les activités.</p>
		</div>
		@if (!configurations.length) {
			<app-ui-button label="Configurer" variant="primary" size="md" iconLeft="settings" type="button" (clicked)="openModal()"></app-ui-button>
		}
	</header>

	<div class="sp-card">
		@if (isLoading) {
			<app-loaderIntervantion [isLoading]="isLoading" [rows]="3"></app-loaderIntervantion>
		} @else if (!configurations.length) {
			<div class="sp-empty">
				<p class="sp-empty__title">Aucune configuration</p>
				<p class="sp-empty__hint">Choisissez le type d’intervention qui marque le début des activités.</p>
			</div>
		} @else {
			<app-ui-table [columns]="tableStructureProgrammatique" [data]="configurations" [actions]="rowActions"></app-ui-table>
		}
	</div>

	<ng-template #rowActions let-item="item">
		<div class="sp-row-actions">
			<app-ui-button iconOnly="edit" variant="ghost" size="sm" ariaLabel="Modifier" type="button" (clicked)="edit(item)"></app-ui-button>
			<app-ui-button iconOnly="delete" variant="danger" size="sm" ariaLabel="Supprimer" type="button" (clicked)="openDeleteConfirm(item)"></app-ui-button>
		</div>
	</ng-template>
</section>

<app-confirm-dialog
	[isVisible]="showDeleteConfirm"
	[itemLabel]="selectedItem?.typeInterventionLibelle || selectedItem?.valeur || ''"
	[isLoading]="deleteLoading"
	(confirmed)="confirmDelete()"
	(cancelled)="cancelDelete()" 
></app-confirm-dialog>

<app-modal [isVisible]="showModal" [title]="isEditing ? 'Modifier la configuration' : 'Configurer la structure programmatique'" (closeEvent)="closeModal()">
	<form [formGroup]="form" (ngSubmit)="save()" class="sp-form">
		<app-select
			label="Début des activités"
			placeholder="Sélectionnez un type d’intervention"
			formControlName="valeur"
			[options]="typeInterventionOptions"
		></app-select>
		@if (form.get('valeur')?.invalid && form.get('valeur')?.touched) {
			<span class="sp-form__error">Le type d’intervention est requis.</span>
		}
		<div class="sp-form__actions">
			<app-ui-button label="Annuler" variant="ghost" size="md" type="button" (clicked)="closeModal()"></app-ui-button>
			<app-ui-button [label]="isEditing ? 'Mettre à jour' : 'Enregistrer'" variant="primary" size="md" iconLeft="save" type="submit" [loading]="isLoading" [disabled]="isLoading || form.invalid"></app-ui-button>
		</div>
	</form>

</app-modal>
